export default "__VITE_ASSET__DaRQK$d7__"